import { observer } from 'mobx-react';
import { FC } from 'react';
import { IApplePayDomain } from '../../types/applePay';
import ApplePayInput from '../../components/ApplePayInput/ApplePayInput';
import applePaySettingsStore from '../../store/applePaySettingsStore';
import Text, { TEXT } from '~/view/components/Text/Text';
import './style.scss';

interface IPropsApplePayDomain {
  domain: IApplePayDomain;
}

const ApplePayDomain: FC<IPropsApplePayDomain> = ({ domain }: IPropsApplePayDomain): JSX.Element => {
  const handleDomainInputChange = (field: keyof IApplePayDomain) => (displayName: string | undefined) => {
    applePaySettingsStore.changeDomainHandler(domain.domain, { [field]: displayName ?? '' });
  };

  return (
    <div className="d-flex flex-column">
      <div className="flex-row gap-30 mt-6">
        <Text type={TEXT.SECTION_HEADER} text={domain.domain} />
        <ApplePayInput title="apple_pay_merchant_id" value={domain.merchantId} onChange={handleDomainInputChange('merchantId')} />
        <ApplePayInput
          title="apple_pay_domain_association_key"
          value={domain.domainAssociationKey}
          onChange={handleDomainInputChange('domainAssociationKey')}
        />
      </div>
    </div>
  );
};

export default observer(ApplePayDomain);
